// extracted by mini-css-extract-plugin
module.exports = {"list":"ProcessSteps_list__zOMnn","item":"ProcessSteps_item__9J7DJ","iconWrapper":"ProcessSteps_iconWrapper__axcCx","icon":"ProcessSteps_icon__7xPcz"};